import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDO4vvY66kOsk_S7Hrv11F6gXlu3C2Gr6Q",
  authDomain: "stridemail-7ec80.firebaseapp.com",
  projectId: "stridemail-7ec80",
  storageBucket: "stridemail-7ec80.appspot.com",
  messagingSenderId: "579073011931",
  appId: "1:579073011931:web:9cfc28f9897f1d695f9cfe",
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
export { db };
